import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Outlet, useLocation } from 'react-router-dom';
import Link from '@mui/material/Link';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import PhoneLockedIcon from '@mui/icons-material/PhoneLocked';
import LockClockIcon from '@mui/icons-material/LockClock';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

export default function Manage() {
    const location = useLocation();
    const currentPath = location.pathname;

    const isSelected = (path) => currentPath === path;

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Mi Cuenta
            </Typography>
            <Grid container spacing={2}>
                <Grid item size={{md:5}}>
                    <List sx={{ width: '100%' }}>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage"
                            selected={isSelected('/account/manage')}
                            sx={{ backgroundColor: isSelected('/account/manage') ? 'rgba(0, 0, 0, 0.08)' : 'inherit' }}
                        >
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                            <ListItemText primary="Perfil" />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage/email"
                            selected={isSelected('/account/manage/email')}
                            sx={{ backgroundColor: isSelected('/account/manage/email') ? 'rgba(0, 0, 0, 0.08)' : 'inherit' }}
                        >
                            <ListItemIcon>
                                <EmailIcon />
                            </ListItemIcon>
                            <ListItemText primary="Correo Electrónico" />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage/change-password"
                            selected={isSelected('/account/manage/change-password')}
                            sx={{ backgroundColor: isSelected('/account/manage/change-password') ? 'rgba(0, 0, 0, 0.08)' : 'inherit' }}
                        >
                            <ListItemIcon>
                                <LockIcon />
                            </ListItemIcon>
                            <ListItemText primary="Contraseña" />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage/external-logins"
                            selected={isSelected('/account/manage/external-logins')}
                            sx={{
                                backgroundColor: isSelected('/account/manage/external-logins') ? 'rgba(0, 0, 0, 0.08)' : 'inherit',
                                pointerEvents: 'none', // Disable interaction
                                opacity: 0.5, // Visually indicate disabled state
                            }}
                        >
                            <ListItemIcon>
                                <PhoneLockedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Redes Sociales" />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage/two-factor-authentication"
                            selected={isSelected('/account/manage/two-factor-authentication')}
                            sx={{
                                backgroundColor: isSelected('/account/manage/two-factor-authentication') ? 'rgba(0, 0, 0, 0.08)' : 'inherit',
                                pointerEvents: 'none', // Disable interaction
                                opacity: 0.5, // Visually indicate disabled state
                            }}
                        >
                            <ListItemIcon>
                                <LockClockIcon />
                            </ListItemIcon>
                            <ListItemText primary="Verificación en Dos Pasos" />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to="/account/manage/personal-data"
                            selected={isSelected('/account/manage/personal-data')}
                            sx={{
                                backgroundColor: isSelected('/account/manage/personal-data') ? 'rgba(0, 0, 0, 0.08)' : 'inherit',
                                pointerEvents: 'none', // Disable interaction
                                opacity: 0.5, // Visually indicate disabled state
                            }}
                        >
                            <ListItemIcon>
                                <PersonRemoveIcon />
                            </ListItemIcon>
                            <ListItemText primary="Datos Personales" />
                        </ListItem>
                    </List>
                </Grid>
                <Grid item size={{md:7}}>
                    <Outlet />
                </Grid>
            </Grid>
        </Box>
    );
}

